export const paginationConfig = {
  itemsPerPageDefault: 8,
  itemsPerPageArticles: 10,
};
